/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Why the user is or is not included for this device
 */
export type AlertSubscriptionDetailsDtoReason = (typeof AlertSubscriptionDetailsDtoReason)[keyof typeof AlertSubscriptionDetailsDtoReason];

export const AlertSubscriptionDetailsDtoReason = {
  ALL_DEVICES: 'all_devices',
  DEVICE_LISTED: 'device_listed',
  PARENT_SWITCH_LISTED: 'parent_switch_listed',
  EXCLUDED_BY_TEMPLATE: 'excluded_by_template',
  NO_TEMPLATE_MATCH: 'no_template_match',
} as const;
